<template>
  <div
    class="d-flex flex-column mt-5 main-wrapper"
    style="
      padding-left: 6px !important;
      padding-right: 6px !important;
      height: 80vh;
    "
  >
    <div class="account-container-wrapper d-flex pl-0 mt-2 py-2">
      <div class="col-lg-6 col-5 my-auto">
        <img src="https://cdn.gold549.com/build/assets/img/theme/profile.png" style="width: 92px; height: 92px" alt="">
      </div>

      <div class="col-lg-6 col-7 p-0">
        <div class="pt-2">
          <div class="d-flex">
            <p class="MuiTypography-root MuiTypography-body1 css-17h40hp mb-1" style="width: 100px"> 
                        {{ $lang('Username', 'အမည်', 'Nama pengguna') }}</p>
            <p class="MuiTypography-root MuiTypography-body1 css-eurmd1 mb-1">: {{$store.state.authUser.name}} </p>
          </div>
          <div class="d-flex">
            <p class="MuiTypography-root MuiTypography-body1 css-17h40hp mb-1" style="width: 100px">
                        {{ $lang('Balance', 'လက်ကျန်ငွေ', 'Baki') }}</p>
            <p class="MuiTypography-root MuiTypography-body1 css-eurmd1 mb-1">:
              <b>{{ Number($store.state.amount).toLocaleString() }}</b>
              {{ $site.currencySymbol }}
            </p>
          </div>
          <div class="d-flex">
            <p class="MuiTypography-root MuiTypography-body1 css-17h40hp mb-1" style="width: 100px">
                        {{ $lang('Phone', 'ဖုန်းနံပါတ်', 'Telefon') }}</p>
            <p class="MuiTypography-root MuiTypography-body1 css-eurmd1 mb-1">: {{ $store.state.authUser.phone }} </p>
          </div>
          <div class="d-flex">
            <p class="MuiTypography-root MuiTypography-body1 css-17h40hp mb-1" style="width: 100px">
                        {{ $lang('Withdraw', 'ငွေထုတ်', 'Pengeluaran') }}</p>
            <p class="MuiTypography-root MuiTypography-body1 css-eurmd1 mb-1">: 0 </p>
          </div>
        </div>
      </div>
  </div>



    <div class="col-lg-12 col-12 pl-0 side-nav-bar-custom">
      <nav class="side-nav card my-2" style="border-radius: 10px;">
        <div>
          <div>
            <!-- Nav items -->
            <ul class="navbar-nav-custom">
              <li class="nav-items">
                <div class="nav-link">
                  <i class="fas fa-user mr-3"></i>
                  <span class="nav-link-text">{{
                    `${$lang('Nick Name', 'Nick Name', 'Nama panggilan')} - ${$store.state.authUser.user_name || ''}`
                  }}</span>
                </div>
              </li>
              <li
                class="nav-items"
                data-toggle="modal"
                data-target="#editUserPassword"
              >
                <div class="nav-link d-flex justify-content-between">
                  <div>
                    <i class="fas fa-key mr-3"></i>
                    <span class="nav-link-text">{{
                      $lang('Change Password', 'လျှို့ဝှက်နံပါတ် ပြောင်းမည်', 'Tukar kata laluan')
                    }}</span>
                  </div>
                  <div>
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </li>
              <li
                class="nav-items"
                @click="() => $router.push('/rule')"
              >
                <div class="nav-link d-flex justify-content-between">
                  <div>
                    <i class="fas fa-book mr-3"></i>
                    <span class="nav-link-text">{{
                      $lang('Rules', 'စည်းကမ်းချက်များ', 'Peraturan')
                    }}</span>
                  </div>
                  <div>
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </li>
              <li class="nav-items">
                <div
                  class="nav-link d-flex justify-content-between"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <div id="navbar-language">
                    <i class="fas fa-language mr-3"></i>
                    <span class="nav-link-text">{{
                      $lang('Change Language', 'ဘာသာစကား ပြောင်းမည်', 'Tukar bahasa')
                    }}</span>
                  </div>

                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="navbar-language"
                  >
                    <a
                      v-for="(item, index) in settingLanguages"
                      :key="item.code"
                      class="dropdown-item d-flex align-items-center"
                      @click="setLangLocalstorage(item.code)"
                    >
                      <img
                        :src="item.flag"
                        alt=""
                        class="mr-2 setting-lang-flag"
                      />
                      {{ languageOptionLabel(item.code) }}
                    </a>
                  </div>

                  <div>
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </li>
              <li class="nav-i">
                <div class="ml-3 nav-link">
                  Version :
                  <span class="text-danger">{{
                    $store.state.androidVersion
                  }}</span>
                </div>
              </li>
            </ul>
            <!-- Divider -->
            <hr class="my-3" />
            <!-- Navigation -->
            <ul class="navbar-nav-custom mb-md-3">
              <li class="nav-items">
                <div class="nav-link active active-pro" @click="logout()">
                  <i class="ni ni-lock-circle-open text-danger mr-3"></i>
                  <span class="nav-link-text text-danger">{{
                    $lang('Log Out', 'ထွက်မည်', 'Log keluar')
                  }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
    <!-- ==== modal for user password edit ==== -->
    <div
      class="modal fade"
      id="editUserPassword"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-form"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal- modal-dialog-centered modal-sm"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-body">
            <div class="card border-0 mb-0">
              <div class="card-body px-lg-5 py-lg-5">
                <div class="form-group">
                  {{ $lang('Old Password', 'လျို့ဝှက်နံပါတ်အဟောင်း။', 'Kata laluan lama') }}
                  <div class="mt-2 input-group">
                    <input class="form-control" v-model="password.old" />
                  </div>
                  <span class="text-danger">{{ errors.old }}</span>
                </div>
                <div class="form-group">
                  {{ $lang('New Password', 'လျို့ဝှက်နံပါတ်အသစ်။', 'Kata laluan baharu') }}
                  <div class="mt-2 input-group">
                    <input class="form-control" v-model="password.new" />
                  </div>
                  <span class="text-danger">{{ errors.new }}</span>
                </div>
                <div class="form-group">
                  {{ $lang('Confirm Password', 'အတည်ပြုလျို့ဝှက်နံပါတ်။', 'Sahkan kata laluan') }}
                  <div class="mt-2 input-group">
                    <input class="form-control" v-model="password.confirm" />
                  </div>
                  <span class="text-danger">{{
                    errors.confirm || errors.confirmPassword
                  }}</span>
                </div>
                <div class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="changeNewPassword"
                  >
                    <div v-if="!isConfirm">
                      {{ $lang('Confirm', 'အတည်ပြုမည်', 'Sahkan') }}
                    </div>

                    <Loading
                      color="#ffffff"
                      v-if="isConfirm"
                      size="24"
                      class="px-4 py-0"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';
import { SETTING_LANGUAGES } from '@/i18n/languages';

export default {
  components: { Loading },
  data() {
    return {
      settingLanguages: SETTING_LANGUAGES,
      password: {
        user_id: this.$store.state.authUser.id,
      },
      isConfirm: false,
      errors: {},
    };
  },
  methods: {
    ...mapActions(['logoutUser', 'fetchUser']),
    languageOptionLabel(code) {
      const labels = {
        en: this.$lang('English', 'အင်္ဂလိပ်စာ', 'Inggeris'),
        mm: this.$lang('Myanmar (Burmese)', 'မြန်မာ (ဗမာစာ)', 'Bahasa Myanmar'),
        ms: this.$lang('Malay (Malaysia)', 'မလေး (မလေးရှား)', 'Bahasa Melayu'),
      };
      return labels[code] || code;
    },
    setLangLocalstorage(language) {
      localStorage.setItem('language', language);
      this.$store.commit('setLanguage', language);
    },
    changeNewPassword() {
      this.errors = {};
      if (!this.password.old) {
        this.errors.old = this.$lang(
          'Old password required',
          'လျို့ဝှက်နံပါတ်အဟောင်း ထည့်ပါ။',
          'Kata laluan lama diperlukan'
        );
        return false;
      }
      if (!this.password.new) {
        this.errors.new = this.$lang(
          'New password required',
          'လျို့ဝှက်နံပါတ်အသစ် ထည့်ပါ။',
          'Kata laluan baharu diperlukan'
        );
        return false;
      }
      if (!this.password.confirm) {
        this.errors.confirm = this.$lang(
          'Confirm password required',
          'အတည်ပြုလျို့ဝှက်နံပါတ် ထည့်ပါ။',
          'Sahkan kata laluan diperlukan'
        );
        return false;
      }
      if (this.password.new !== this.password.confirm) {
        this.errors.confirmPassword = this.$lang(
          'New passwords not match',
          'လျှို့ဝှက်နံပါတ် မတူညီပါ။',
          'Kata laluan tidak sepadan'
        );
        return false;
      }
      this.isConfirm = true;
      Dialog.confirm({
        title: this.$lang('Are you sure?', 'သေချာပါသလား?', 'Adakah anda pasti?'),
        cancelButtonText: this.$lang('Cancel', 'မလုပ်တော့ပါ။', 'Batal'),
        confirmButtonText: this.$lang('Sure', 'သေချာပြီ။', 'Pasti'),
      })
        .then(() => {
          this.updateUser();
        })
        .catch(() => {});
      this.isConfirm = false;
      return true;
    },
    async updateUser() {
      try {
        const res = await axios.post(
          '/auth/userPasswordChange',
          this.password,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        Toast.success(this.$lang('Success', 'အောင်မြင်သည်။', 'Berjaya'));
        this.password = {};
        this.errors = {};
        $('#editUserPassword').modal('hide');
      } catch (error) {
        Toast.fail(this.$lang('Fail', 'ကျရှုံးသည်။', 'Gagal'));
      }
    },
    logout() {
      Dialog.confirm({
        title: this.$lang('Are you sure to log out?', 'ထွက်မှာ သေချာပါသလား?', 'Pasti mahu log keluar?'),
        cancelButtonText: this.$lang('Cancel', 'မထွက်တော့ပါ', 'Batal'),
        confirmButtonText: this.$lang('Sure', 'သေချာပြီ', 'Pasti'),
      })
        .then(async () => {
          await this.logoutUser();
          this.$router.push('/auth/login');
          Toast.success(this.$lang('Logged out!', 'ထွက်ပြီးပြီ', 'Telah log keluar'));
        })
        .catch(() => {});
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
  },
};
</script>
<style scoped>
.css-17h40hp {
    margin: 0px;
    line-height: 1.5;
    font-size: 14px;
    /* font-family: NotoSansMyanmar; */
    font-weight: 700 !important;
}
.error {
  margin-bottom: 13px;
  height: 40px;
  display: flex;
  align-items: center;
  color: red;
  border: 1px solid red;
  border-radius: 8px;
  padding: 0px 15px;
  background: #ff000014;
  font-weight: bold;
}
.account-container-wrapper {
    width: auto;
    height: 200px;
    border-radius: 10px;
    color: black;
    background: #ffffff;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  }

.setting-lang-flag {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
}
</style>
